<template>
  <b-list-group ref="listRef" flush>
    <slot v-bind="items">
      <b-list-group-item
        v-for="item in items"
        :key="`advanced-scroll-list-placeholder-item-${item}`"
        class="py-1 px-0"
      >
        <b-skeleton
          :width="`${Math.random() * 100 + 150}px`"
          height="20px"
          class="my-1"
          animation="fade"
        ></b-skeleton>
      </b-list-group-item>
    </slot>
  </b-list-group>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AdvancedScrollListLoader',
  setup() {
    const items = [1, 2, 3, 4, 5]

    return {
      items
    }
  }
})
</script>

<style scoped>
.list-group >>> .list-group-item > div {
  min-width: 50px;
}

.list-group >>> .list-group-item .custom-checkbox {
  margin-left: 12px;
}
</style>
